/**
 * Single source of truth for "does this user have full access to the app?".
 *
 * Used by UI components to hide controls that lead to routes the user
 * can't actually reach (e.g. Settings inside UserMenu when displayed on
 * TermsConsentPage). The route-level enforcement lives in OnboardingGuard
 * and the backend `requireTermsAccepted` middleware — this helper is
 * purely for UX, not security.
 *
 * Keep the predicate aligned with OnboardingGuard's gates so that hidden
 * controls never disagree with what the guard would actually allow.
 */
export function canAccessApp(userProfile) {
  if (!userProfile) return false;
  if (!userProfile.terms_accepted_at) return false;
  // Billing and onboarding gates already short-circuit at the route level
  // via OnboardingGuard. We don't replicate them here because their state
  // (subscription, has_logged_in, onboarding_completed) is not always
  // populated where UserMenu renders (e.g. mid-onboarding). The terms
  // check is the one gate that's universally relevant.
  return true;
}
